import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import moment from 'moment';

import { BlueSwipeCustomerCardSchema } from './validation';
import { buildDropdown } from './edit-bankaccount-billing-component';

const defaultInitialValues = {
  card_number: '',
  card_expMonth: '',
  card_expYear: '',
  card_cvv: ''
}

const cssFormControlError = "form-control error-input";
const cssFormControl = "form-control";

export function getMonthArray() {
  let monthArray = [];
  for (let i = 1; i <= 12; i++) {
    monthArray.push(i >= 10 ? i.toString() : '0' + i.toString());
  }
  return monthArray;
}

export function getYearArray() {
  let yearArray = [];
  let currentYear = moment().year();
  for (let i = 0; i < 20; i++) { yearArray.push(currentYear + i); }
  return yearArray;
}

class CreditCardForm extends Component {
  constructor(props) {
    super(props);

    this.state = { errors: null, isSubmitting: false }
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.errorMessage !== prevProps.errorMessage && this.state.isSubmitting) {
      this.setState({ isSubmitting: false });
    }
  }

  onSubmit(values, form) {
    let { onSubmit } = this.props;
    this.setState({ isSubmitting: true });
    onSubmit(values, form);
  }

  renderCardExpiration(isMobile, errors, touched) {
    const cvvClass = (errors.card_cvv && touched.card_cvv) ? cssFormControlError : cssFormControl;
    return isMobile
      ? (
        <div><div className="fieldgroup row">
          <div className="d-flex align-items-center mr-3">
            Expires:
          </div>
          <div className="col p-0 fieldgroup-required">
            {
              buildDropdown("card_expMonth", getMonthArray(), "Exp. Month", "MM", (errors.card_expMonth && touched.card_expMonth))
            }
          </div>
          <div className="d-flex align-items-center pl-1 pr-1">&nbsp;/&nbsp;</div>
          <div className="col p-0 fieldgroup-required">
            {
              buildDropdown("card_expYear",
                getYearArray(), "Exp. Year", "YYYY", (errors.card_expYear && touched.card_expYear)
              )
            }
          </div>
          <ErrorMessage
            name="card_expMonth" component="div" className="error-message w-100"
          />
        </div>
          <div className="fieldgroup fieldgroup-required">
            <Field
              name="card_cvv"
              type="text" placeholder="CVV" className={cvvClass}
            />
            <ErrorMessage
              name="card_cvv" component="div" className="error-message w-100" />
          </div> </div>)
      : (<div className="fieldgroup row">
        <div className="col-8 d-flex pl-0">
          <div className="d-flex align-items-center mr-3">
            Exp:
          </div>
          <div className="col p-0 fieldgroup-required fieldgroup-select">
            {
              buildDropdown("card_expMonth", getMonthArray(), "Exp. Month", "MM", (errors.card_expMonth && touched.card_expMonth))
            }
          </div>
          <div className="d-flex align-items-center pl-1 pr-1">
            &nbsp;/&nbsp;
          </div>
          <div className="col p-0 fieldgroup-required fieldgroup-select">
            {buildDropdown("card_expYear", getYearArray(), "Exp. Year", "YYYY", (errors.card_expYear && touched.card_expYear))}
          </div>
        </div>
        <div className="col-4 pr-0 fieldgroup-required">
          <Field name="card_cvv"
            type="text" placeholder="CVV"
            className={cvvClass}
          />
        </div>
        <ErrorMessage name="card_expMonth" component="div" className="error-message w-100" />
        <ErrorMessage name="card_cvv" component="div" className="error-message w-100" />
      </div>);
  }

  render() {
    let { onBack, errorMessage, initialValues, isMobile } = this.props;
    return (
      <Formik
        validationSchema={BlueSwipeCustomerCardSchema}
        initialValues={initialValues ? initialValues : defaultInitialValues}
        onSubmit={this.onSubmit}>
        {({ errors, touched, isSubmitting }) => (
          <Form>
            <div>
              <p>Credit card information is used to verify that you are a real person.
                It is securely encrypted and stored by our Payment Processor. You are never charged until you make a reservation.</p>
              <div>
                <div className="fieldgroup row fieldgroup-required">
                  <Field
                    name="card_number"
                    type="number"
                    placeholder="Credit Card Number"
                    className={(errors.card_number && touched.card_number) ? cssFormControlError : cssFormControl}
                  />
                  <ErrorMessage name="card_number" component="div" className="error-message" />
                </div>
                {this.renderCardExpiration(isMobile, errors, touched)}
              </div>
              <div>
                {errorMessage && (<div className="error-message mb-3">{errorMessage.message}</div>)}
                <div className="button-row row">
                  <div className="col">
                    <label onClick={onBack}>Cancel</label>
                  </div>
                  <div className="col text-right">
                    <button className="btn btn-primary" disabled={isSubmitting} type="submit">{isSubmitting ? 'Verifying...' : 'Submit'}</button>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default CreditCardForm;
